import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { getProposalState } from 'proposals/api/procurementApiClient'

export const useProposalStateQuery = (token: string): UseQueryResult<GetProposalStateResponseType> => {
  return useQuery<GetProposalStateResponseType>({
    queryKey: ['proposal-state', token],
    queryFn: () => getProposalState(token),
    refetchOnWindowFocus: false
  })
}
